import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';

export const activitySalesRoutes: MenuInterface[] = [
    {
        code: 'SalesActivityParameters',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.Sales)
    },
    {
        code: 'SalesConfigPermanence',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.Sales)
    },
    {
        code: 'SalesCatalog',
        route: getRouteByActivityType('Catalog', RouteActivityType.Sales)
    },
    {
        code: 'SalesConfigActions',
        route: getRouteByActivityType('GroupedActions', RouteActivityType.Sales)
    },
    {
        code: 'SalesConfigFormFields',
        route: getRouteByActivityType('FormField', RouteActivityType.Sales)
    },
    {
        code: 'SalesConfigForm',
        route: getRouteByActivityType('Forms', RouteActivityType.Sales)
    },
    {
        code: 'SalesNewSale',
        route: getRouteByActivityType('NewSale', RouteActivityType.Sales)
    },
    {
        code: 'SalesDeliver',
        route: getRouteByActivityType('Deliver', RouteActivityType.Sales)
    },
    {
        code: 'SalesList',
        route: getRouteByActivityType('OrderList', RouteActivityType.Sales)
    },
    {
        code: 'SalesDeliveriesList',
        route: getRouteByActivityType('DeliveriesList', RouteActivityType.Sales)
    },
    {
        code: 'SalesInvoicesList',
        route: getRouteByActivityType('InvoicesList', RouteActivityType.Sales)
    },
    {
        code: 'SalesNewSupplierOrder',
        route: getRouteByActivityType('NewSupplierOrder', RouteActivityType.Sales)
    },
    {
        code: 'SalesSupplierOrdersList',
        route: getRouteByActivityType('SupplierOrdersList', RouteActivityType.Sales)
    },
    {
        code: 'SalesSupplierInvoicesList',
        route: getRouteByActivityType('SupplierInvoicesList', RouteActivityType.Sales)
    },
    {
        code: 'SalesStockQuantities',
        route: getRouteByActivityType('StockQuantities', RouteActivityType.Sales)
    },
    {
        code: 'SalesStockMovements',
        route: getRouteByActivityType('StockMovements', RouteActivityType.Sales)
    },
    {
        code: 'SalesInventoriesList',
        route: getRouteByActivityType('InventoriesList', RouteActivityType.Sales)
    },
    {
        code: 'SalesNewInventory',
        route: getRouteByActivityType('NewInventory', RouteActivityType.Sales)
    },
    {
        code: 'SalesConfigStatusManagement',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Sales)
    },
    {
        code: 'SalesPrintBalance',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Sales)
    },
    {
        code: 'SalesPrintFormOrders',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Sales)
    },
    {
        code: 'SalesSuppliersFreeOrdersList',
        route: getRouteByActivityType('SuppliersFreeOrdersList', RouteActivityType.Sales)
    },
    {
        code: 'SalesSuppliersFreeInvoicesList',
        route: getRouteByActivityType('SuppliersFreeInvoicesList', RouteActivityType.Sales)
    },
    {
        code: 'SalesBeneficiariesFreeOrdersList',
        route: getRouteByActivityType('BeneficiariesFreeOrdersList', RouteActivityType.Sales)
    },
    {
        code: 'SalesBeneficiariesFreeInvoicesList',
        route: getRouteByActivityType('BeneficiariesFreeInvoicesList', RouteActivityType.Sales)
    },
    {
        code: 'SalesFreeEntriesModelsList',
        route: getRouteByActivityType('FreeEntriesModelsList', RouteActivityType.Sales)
    },
    {
        code: 'SalesAllocation',
        route: [
            {
                content: 'activity/sales/allocations/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'SalesPrintStocks',
        route: [
            {
                content: 'activity/sales/prints/stocks/criteria',
                focus: 'activity/sales/prints/stocks/informations',
            }, 'content'
        ]
    },
    {
        code: 'SalesStockNewCession',
        route: [
            {
                content: 'activity/sales/stocks/stock-transfer/new',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'SalesStockCessionReception',
        route: [
            {
                content: 'activity/sales/stocks/stock-transfer/reception/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'SalesStockCessionList',
        route: [
            {
                content: 'activity/sales/stocks/stock-transfer/history/list',
                focus: 'empty',
            }, 'content'
        ]
    },
];
